module.exports = __webpack_public_path__ + "static/media/couch.26da83e6.svg";